import styled from 'styled-components'
import { EDITOR_COLOR_TILE_GRID_WIDTH_PX } from './EditorTextBoxToolbar.geometry'

type ShadowMenuProps = {
  /** The hex view shows in place of the colour tiles. */
  $hex?: boolean
}

/**
 * As wide as the colour tiles it holds, like the outline menu; while the hex
 * view replaces them, as wide as its picker and input row need, like the
 * outline colour flyout.
 */
export const ShadowMenu = styled.div<ShadowMenuProps>`
  width: ${({ $hex }) =>
    $hex ? 'max-content' : `${EDITOR_COLOR_TILE_GRID_WIDTH_PX}px`};
`

/** A control's name, over its stepper. */
export const ShadowLabel = styled.div`
  padding: 8px 12px 0;
  color: #525252;
  font-size: 12px;
`
